import compact from 'lodash/compact';
import { Fragment } from 'react';

import { localizeRelativeTime } from 'utils/i18nHelpers';

import { useTranslations } from '../hooks/useTranslations';
import { ImageMetadata } from '../types';
import { getFileSize } from '../utils/strings';

// the bullet-separated list of details about the image
export const ItemDetails = ({ metadata }: { metadata: ImageMetadata }) => {
  const { t } = useTranslations();
  const createdDate = metadata.createdAt ? new Date(metadata.createdAt).toString() : undefined;
  const relativeCreated = localizeRelativeTime(createdDate);
  const details = compact([
    metadata.size && getFileSize(metadata.size),
    metadata.width && metadata.height && (
      <>
        {metadata.width}&nbsp;&times;&nbsp;{metadata.height}
        {t('abbreviation.pixel')}
      </>
    ),
    metadata.creatorName &&
      metadata.createdAt &&
      t('caption.createdBy', { when: relativeCreated.label, name: metadata.creatorName }),
    !metadata.creatorName &&
      metadata.createdAt &&
      t('caption.created', { when: relativeCreated.label }),
  ]);

  return (
    <>
      {details.map((detail, idx, ary) => {
        return (
          <Fragment key={`detail-${idx}`}>
            <>{detail}</>
            {idx < ary.length - 1 ? <> &bull; </> : ''}
          </Fragment>
        );
      })}
    </>
  );
};
